'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var includedProductsInPackComponent = exports.includedProductsInPackComponent = {
    template: require('./included-products-in-pack.html'),
    bindings: {
        product: '<',
        quantityChanged: '&',
        context: '<',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "Analytics", "productService", function includedProductsInPackController(common, Analytics, productService) {
        'ngInject';

        var vm = this;
        vm.productClicked = productClicked;
        vm.changeViewMode = changeViewMode;
        vm.packQuantityChanged = packQuantityChanged;
        vm.getProductDiscounts = getProductDiscounts;
        vm.viewMode = window.localStorage.getItem('viewMode') || 'list';

        // buy quantity pack changed
        function packQuantityChanged(product) {
            vm.productsQuantityChanged = true;
            vm.quantityChanged(product);
        }

        // save in local storage when viewmode is changed
        function changeViewMode(viewMode) {
            window.localStorage.setItem('viewMode', viewMode);
            vm.viewMode = viewMode;
        }

        /*Google Analytics */
        function productClicked() {
            Analytics.addProduct(vm.product.id, vm.product.name, null, vm.product.brand, null, vm.product.price, null, null, null, { dimension1: vm.product.sellerId, dimension2: vm.product.sellerName, dimension3: vm.product.discountId });
            Analytics.productClick('Included product in pack');
            common.log.info('Analysis: product clicked from included product in pack', vm.product.name);
        }

        /* Load product discounts when discount is clicked */
        function getProductDiscounts(product) {
            return productService.getProductDiscounts(product.id);
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/product/components/included-products-in-pack.js
// module id = 961
// module chunks = 0